export const quotationType = {
  I: 'Per Shipment',
  C: 'Contract/Master'
}

export const printSi = {
  I: 'Insured Value',
  L: 'Limit per Conveyance'
}
